import { css, jsx } from '@emotion/react';
import { BREAKPOINTS } from '../constants.es.js';

const ModalContentFooterStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "var(--zds-space-12, 10px)",
  [`@media screen and (min-width: ${BREAKPOINTS.tablet})`]: {
    flexDirection: "row",
    justifyContent: "end",
    gap: "var(--zds-space-20, 20px)"
  }
});
const ModalContentFooter = ({ children }) => {
  return jsx("footer", { css: ModalContentFooterStyles, "data-zds": true }, children);
};

export { ModalContentFooter };
//# sourceMappingURL=ContentFooter.es.js.map
